import { reactive } from "vue"
import { Popup } from "./odsPopup.ts";

const popupManager:{popups: Popup[]} = reactive({
    popups: []
});

const usePopup = (component, popupOptions) => {
    const popupIndex = popupManager.popups.findIndex(item => item.id == popupOptions.id)
    if(popupIndex === -1){
      const popup = new Popup({
        id: popupOptions.id,
        canClose: popupOptions.canClose,
        size: popupOptions.size,
        position: popupOptions.position,
        overflow: popupOptions.overflow,
        component: component,
        componentProps: popupOptions.componentProps
      })
      popupManager.popups.push(popup)
    }
}

const closePopup = (id) => {
    const popupIndex = popupManager.popups.findIndex(item => item.id == id)
    if(popupIndex > -1){
        popupManager.popups[popupIndex].setActive(false)
        setTimeout(() => {
          popupManager.popups.splice(popupIndex, 1)
        }, 300)
        
    }

}

export { usePopup, closePopup }
export { popupManager }